module.exports = __webpack_public_path__ + "img/chiesa.cb02eca2.jpg";